export const UPDATE_FILE_REFERENCE_FAILURE = 'UPDATE_FILE_REFERENCE_FAILURE';

export const updateFileReferenceFailure = (payload: Error) => ({
    type: UPDATE_FILE_REFERENCE_FAILURE,
    payload,
    error: true,
});
